var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.063,
    height: 62.068,
    viewBox: "0 0 62.063 62.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medical-service",
    transform: "translate(-12.244 -12.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14635",
    "data-name": "Path 14635",
    d: "M43.258,12.75a30.513,30.513,0,0,0-19.832,7.323.744.744,0,1,0,.968,1.13,29.024,29.024,0,1,1-2.839,2.787A.744.744,0,1,0,20.443,23,30.51,30.51,0,1,0,43.258,12.75Z",
    transform: "translate(0 0)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14636",
    "data-name": "Path 14636",
    d: "M64.386,63.945a.744.744,0,0,0,1.051-.046,24.6,24.6,0,1,0-2.5,2.374.744.744,0,1,0-.948-1.148,23.126,23.126,0,1,1,2.349-2.232.744.744,0,0,0,.048,1.052Z",
    transform: "translate(-4.027 -4.026)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14637",
    "data-name": "Path 14637",
    d: "M68.994,52.5a.744.744,0,1,0,0,1.488h.819a.744.744,0,1,0,0-1.488Z",
    transform: "translate(-22.462 -16.087)",
    fill: "#0b2ff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14638",
    "data-name": "Path 14638",
    d: "M48.785,69.274h8.037a2.831,2.831,0,0,0,2.828-2.828v-6.8h6.8a2.831,2.831,0,0,0,2.828-2.828V48.785a2.831,2.831,0,0,0-2.828-2.828H59.724a.744.744,0,0,0,0,1.488h6.722a1.341,1.341,0,0,1,1.339,1.339v8.037a1.341,1.341,0,0,1-1.339,1.339H58.905a.744.744,0,0,0-.744.744v7.541a1.341,1.341,0,0,1-1.339,1.339H48.785a1.341,1.341,0,0,1-1.339-1.339V58.906a.744.744,0,0,0-.744-.744H39.161a1.341,1.341,0,0,1-1.339-1.339V48.785a1.341,1.341,0,0,1,1.339-1.339H46.7a.744.744,0,0,0,.744-.744v-7.54a1.341,1.341,0,0,1,1.339-1.339h8.037a1.341,1.341,0,0,1,1.339,1.339v4.564a.744.744,0,1,0,1.488,0V39.162a2.831,2.831,0,0,0-2.828-2.828H48.785a2.831,2.831,0,0,0-2.828,2.828v6.8h-6.8a2.831,2.831,0,0,0-2.828,2.828v8.037a2.831,2.831,0,0,0,2.828,2.828h6.8v6.8a2.831,2.831,0,0,0,2.828,2.828Z",
    transform: "translate(-9.545 -9.544)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMed);
export default __webpack_public_path__ + "static/media/med.1c196594458cf1e7a442071008069a9f.svg";
export { ForwardRef as ReactComponent };